import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {RootState} from '../../app/rootReducer'
import {AuthServiceToken} from '../../types/authServiceToken'

export const generalSlice = createSlice({
    name: 'general',
    initialState: {
        featureAppId: '',
        backendUrl: '',
        campaignCode: '',
        logged: undefined,
        loading: false,
        isDealerWeb: false,
        priceList: '',
        priceListData: null,
        layout: '',
        brand: '',
        campaignId: '',
    },
    reducers: {
        setBackendUrl(
            state: RootState,
            action: PayloadAction<string | undefined>
        ): void {
            state.backendUrl = action.payload
        },
        setCampaignCode(
            state: RootState,
            action: PayloadAction<string | undefined>
        ): void {
            state.campaignCode = action.payload
        },
        setPriceList(
            state: RootState,
            action: PayloadAction<string | undefined>
        ): void {
            state.priceList = action.payload
        },
        setLayout(
            state: RootState,
            action: PayloadAction<string | undefined>
        ): void {
            state.layout = action.payload
        },
        setPriceListData(
            state: RootState,
            action: PayloadAction<object | null>
        ): void {
            state.priceListData = action.payload
        },
        setLoading(state: RootState, action: PayloadAction<boolean>): void {
            state.loading = action.payload
        },
        setLogged(state: RootState, action: PayloadAction<boolean>): void {
            state.logged = action.payload
        },
        setAuthServiceToken(
            state: RootState,
            action: PayloadAction<AuthServiceToken>
        ): void {
            state.authServiceToken = action.payload
        },
        setDealerWeb(state: RootState, action: PayloadAction<boolean>): void {
            state.isDealerWeb = action.payload
        },
        setBrand(
            state: RootState,
            action: PayloadAction<string | undefined>
        ): void {
            state.brand = action.payload
        },
        setCampaignId(
            state: RootState,
            action: PayloadAction<string | undefined>
        ): void {
            state.campaignId = action.payload
        },
    },
})

export const {
    setDealerWeb,
    setBackendUrl,
    setPriceList,
    setPriceListData,
    setCampaignCode,
    setLoading,
    setLogged,
    setAuthServiceToken,
    setLayout,
    setBrand,
    setCampaignId,
} = generalSlice.actions

export default generalSlice.reducer
